import React, { ReactNode } from "react";
import { Chip, SxProps } from "@mui/material";
import { JobType } from "types";
import { useTranslation } from "react-i18next";
import {
  Attractions,
  Phishing,
  Sell,
  TrackChanges,
  WarningAmber,
} from "@mui/icons-material";

export interface JobTypeProps {
  sx?: SxProps;
  type: JobType;
  size?: "small" | "medium";
}

const JobTypeChip = ({ sx, type, size }: JobTypeProps): ReactNode => {
  const { t } = useTranslation();

  return (
    <Chip
      sx={{
        ...sx,
        width: 100,
        fontWeight: 500,
      }}
      color={"primary"}
      label={t(`jobType.${type}`, { ns: "enums" })}
      variant={"outlined"}
      size={size}
    />
  );
};

const handleChipColor = (
  t: JobType,
): "primary" | "secondary" | "error" | "success" | "info" | "warning" => {
  switch (t) {
    case JobType.TAG:
      return "error";
    case JobType.TOW:
      return "success";
    case JobType.BOOT:
      return "warning";
    case JobType.PATROL:
      return "info";
    default:
      return "warning";
  }
};

const getChipIcon = (jt: JobType) => {
  switch (jt) {
    case JobType.TAG:
      return <WarningAmber />;
    case JobType.TOW:
      return <Phishing />;
    case JobType.BOOT:
      return <Attractions />;
    case JobType.PATROL:
      return <TrackChanges />;
    default:
      return <Sell />;
  }
};

export default JobTypeChip;
